// extracted by mini-css-extract-plugin
export var content = "_cc-3";
export var list = "_cc-4";
export var settingsContent = "_cc-7";
export var settingsPanel = "_cc-8";
export var state = "_cc-6";
export var triggerBadge = "_cc-2";
export var triggerButton = "_cc-1";
export var triggerShell = "_cc-0";
export var unreadDot = "_cc-5";